// Copyright Epic Games, Inc. All Rights Reserved.

export default {
  messages: {
    "error.errorCode": "Código de error:",
    "error.search":
      "Busca en nuestra base de conocimiento para obtener más información",
    dismiss: "descartar",
    "installation.title": "",
    "cancelation.button": "Cancelar",
  },
  errorCodes: {
    "EOS-UI-NF": {
      title: "Error de iniciación",
      description:
        "No hemos podido procesar la página. Ponte en contacto con el equipo de asistencia.",
    },
    "EOS-UI-UE": {
      title: "Ha habido un problema.",
      description:
        "Ha habido un problema. Ponte en contacto con el equipo de asistencia.",
    },
    "EOS-IN-BC": {
      title: "Error de instalación",
      description:
        "No hemos podido mostrar el progreso de instalación. Ponte en contacto con el equipo de asistencia.",
    },
    "EOS-IN-UE": {
      title: "Error de instalación",
      description:
        "Ha habido un problema. Ponte en contacto con el equipo de asistencia.",
    },
    "EOS-IN-FF": {
      title: "Error de instalación",
      description:
        "No hemos podido establecer conexión con Epic Online Services. Ponte en contacto con el equipo de asistencia.",
    },
    "EOS-IN-FF-*": {
      title: "Error de instalación",
      description:
        "No hemos podido enviar la solicitud a Epic Online Services. Ponte en contacto con el equipo de asistencia.t",
    },
    fallback: {
      title: "Ha habido un problema.",
      description:
        "Ha habido un problema. Ponte en contacto con el equipo de asistencia.",
    },
  },
};
